import {Occupancy} from "@variocube/app-api";
import {
    Avatar,
    PushButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    useOccupancies,
    useStorageItemValue
} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useMemo} from "react";
import {CubeOrder, OrderStatus, OrderStorage} from "../model";
import {CustomerCell, OrderCell, OrderStatusCell} from "./common";
import {cleanerLog} from "../cleaner";
import {useLocalization} from "../../i18n";

interface PickupTableProps {
    onPickup: (order: CubeOrder) => void;
}

export function PickupTable({onPickup}: PickupTableProps) {
    const {t} = useLocalization();
    const orders = useStorageItemValue<OrderStorage>("orders");
    const displayOrders = useMemo(() => {
        return Object.values(orders ?? {})
            .filter(order => [OrderStatus.Cleaning, OrderStatus.WaitingPickup].indexOf(order.orderStatus) >= 0);
    }, [orders]);

    const occupancies = useOccupancies();

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>{t("Order")}</TableCell>
                    <TableCell>{t("Status")}</TableCell>
                    <TableCell>{t("Customer")}</TableCell>
                    <TableCell>{t("Box")}</TableCell>
                    <TableCell>{t("Action")}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {displayOrders && displayOrders.map(order => {
                    const occupancy = occupancies && occupancies.filter(occupancy => occupancy.accessCode == order.accessCode).pop();
                    return (
                        <PickupTableRow
                            order={order}
                            occupancy={occupancy}
                            key={order.orderId}
                            onPickup={onPickup}
                        />
                    )
                })}
            </TableBody>
        </Table>
    );
}

interface PickupTableRowProps {
    order: CubeOrder;
    occupancy?: Occupancy;
    onPickup: (order: CubeOrder) => void;
}

function PickupTableRow({order, occupancy, onPickup}:PickupTableRowProps) {
    //const strings = useStrings(resources);
    const {t} = useLocalization();
    const pickupHistory = cleanerLog.pickupHistory.get(order.orderId);
    const handlePickup = useCallback(() => onPickup(order), [onPickup, order]);
    return (
        <TableRow>
            <OrderCell order={order}/>
            <OrderStatusCell order={order}/>
            <CustomerCell order={order}/>
            <TableCell>
                {occupancy &&
                    <Avatar size={1.5}>{occupancy.boxNumber}</Avatar>
                }
            </TableCell>
            <TableCell>
                {occupancy && order.orderStatus == OrderStatus.WaitingPickup &&
                <PushButton primary onClick={handlePickup}>
                    {t("DoPickup")}
                </PushButton>
                }
                {!occupancy && (
                    <div>
                        {t("AlreadyPickedUp")}
                        {pickupHistory && (
                            <span>&nbsp;{(pickupHistory.length > 1 ? t("Boxes") : t("Box"))} {pickupHistory.join(", ")}</span>
                        )}
                    </div>
                )}
            </TableCell>
        </TableRow>
    )
}
